import React, { Component, Fragment } from 'react'
import pt from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { get } from 'lodash-es'

import { openMod, closeHelperMod, openHelperMod } from '../../modules/mods'
import { requestOpenCreateCollection } from '../../modules/menus'
import { setThumbnailType, setLayoutType } from '../../modules/viewSettings'

import './style.scss'

import Arrow from '../icon/PickContextMenuArrow'
import Magnifier from '../icon/Magnifier'
import ViewTrim from '../icon/ViewTrim'
import ViewSquare from '../icon/ViewSquare'
import ViewPoster from '../icon/ViewPoster'
import SortBy from '../icon/SortBy'
import DotMenu from '../icon/DotMenu'
import Info from '../icon/Info'
import AddPickTop from '../icon/AddPickTop'
import SaveButton from '../icon/SaveButton'
import ArrowUp from '../icon/ArrowUp'
import FeedGallery from '../icon/FeedGallery'
import FeedSquare from '../icon/FeedSquare'
import FeedStack from '../icon/FeedStack'
import FeedGrid from '../icon/FeedGrid'
import FeedStage from '../icon/FeedStage'
import FeedTrim from '../icon/FeedTrim'
import FeedPoster from '../icon/FeedPoster'

class FeedContextMenu extends Component {
  handleThumbnailSwitch = thumbnailType => {
    this.props.setThumbnailType(thumbnailType)
  }

  render() {
    const {
      isInFeedsFilter,
      openHelperMod,
      isInCards,
      isInCollection,
      isInSaved,
      openMod,
      user,
      requestOpenCreateCollection,
      directionLeft,
      isFloatingButtonPressed,
      isInSavedFeed,
      isInHome,
      setLayoutType
    } = this.props

    const username = get(user, 'username')
    const menuDirection = directionLeft ? 'feed-context-menu--left' : null

    return (
      <div className={`feed-context-menu ${menuDirection}`}>
        <ul className="feed-context-menu__list">
          {!isInHome ? (
            <Fragment>
              <li className="feed-context-menu__list-item feed-context-menu__list-item--search">
                <div className="feed-context-menu__list-icon feed-context-menu__list-icon--magnifier">
                  <Magnifier />
                </div>
                Search this Collection
              </li>
              <span className="feed-context-menu__separator" />
              <li className="feed-context-menu__list-item">
                <div className="feed-context-menu__list-icon feed-context-menu__list-icon--arrowUp">
                  <ArrowUp />
                </div>
                Sort by...
              </li>
              <li className="feed-context-menu__list-item">
                <div className="feed-context-menu__list-icon feed-context-menu__list-icon--gallery">
                  <FeedGallery />
                </div>
                Change Item Layout
                <span className="feed-context-menu__arrow">
                  <Arrow />
                </span>
                <ul
                  className={`feed-context-menu__list feed-context-menu__submenu ${
                    isFloatingButtonPressed ? 'feed-context-menu__submenu--show' : ''
                  }`}
                >
                  <li
                    className="feed-context-menu__list-item"
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      setLayoutType('list')
                    }}
                  >
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--stack">
                      <FeedStack />
                    </div>
                    List
                  </li>
                  <li
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      setLayoutType('grid')
                    }}
                    className="feed-context-menu__list-item"
                  >
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--grid">
                      <FeedGrid />
                    </div>
                    Grid
                  </li>
                  <li
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      setLayoutType('gallery')
                    }}
                    className="feed-context-menu__list-item"
                  >
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--gallery">
                      <FeedGallery />
                    </div>
                    Gallery
                  </li>
                  <li
                    className="feed-context-menu__list-item"
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                    }}
                  >
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--stage">
                      <FeedStage />
                    </div>
                    Stage
                  </li>
                </ul>
              </li>
              <li className="feed-context-menu__list-item">
                <div className="feed-context-menu__list-icon feed-context-menu__list-icon--square">
                  <FeedSquare />
                </div>
                Change Thumbnail Style
                <span className="feed-context-menu__arrow">
                  <Arrow />
                </span>
                <ul
                  className={`feed-context-menu__list feed-context-menu__submenu ${
                    isFloatingButtonPressed ? 'feed-context-menu__submenu--show' : ''
                  }`}
                >
                  <li
                    className="feed-context-menu__list-item"
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      this.handleThumbnailSwitch('trimmed')
                    }}
                  >
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--trim">
                      <FeedTrim />
                    </div>
                    Trim
                  </li>
                  <li
                    className="feed-context-menu__list-item"
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      this.handleThumbnailSwitch('square')
                    }}
                  >
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--square">
                      <FeedSquare />
                    </div>
                    Square
                  </li>
                  <li
                    className="feed-context-menu__list-item"
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      this.handleThumbnailSwitch('poster')
                    }}
                  >
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--poster">
                      <FeedPoster />
                    </div>
                    Poster
                  </li>
                </ul>
              </li>
              <li className="feed-context-menu__list-item">
                <div className="feed-context-menu__list-icon feed-context-menu__list-icon--dots">
                  <DotMenu />
                </div>
                More View Options
              </li>
            </Fragment>
          ) : null}

          {isInCards ? (
            <li className="feed-context-menu__list-item">
              <div className="feed-context-menu__list-icon">
                <AddPickTop width="20px" height="20px" />
              </div>
              Add a Card
              <ul
                className={`feed-context-menu__list feed-context-menu__submenu ${
                  isFloatingButtonPressed ? 'feed-context-menu__submenu--show' : ''
                }`}
              >
                <li
                  className="feed-context-menu__list-item"
                  onClick={() =>
                    openMod({ type: 'addPick', args: { transparentBg: true }, params: { fromMyPicks: true } })
                  }
                >
                  <div className="feed-context-menu__list-icon">
                    <AddPickTop width="20px" height="20px" />
                  </div>
                  Pick from a Link
                </li>
                <li className="feed-context-menu__list-item">
                  <Link to={`../@${username}/saved`}>
                    <div className="feed-context-menu__list-icon">
                      <AddPickTop width="20px" height="20px" />
                    </div>
                    Pick from Saved Cards
                  </Link>
                </li>
              </ul>
            </li>
          ) : null}

          {isInCollection ? (
            <li className="feed-context-menu__list-item">
              <div className="feed-context-menu__list-icon">
                <AddPickTop width="20px" height="20px" />
              </div>
              Add a Collection
              <ul className="feed-context-menu__list feed-context-menu__submenu">
                <li className="feed-context-menu__list-item" onClick={() => requestOpenCreateCollection()}>
                  <div className="feed-context-menu__list-icon">
                    <AddPickTop width="20px" height="20px" />
                  </div>
                  Create New Collection
                </li>
                <li
                  className="feed-context-menu__list-item"
                  onClick={() =>
                    openMod({ type: 'addPick', args: { transparentBg: false }, params: { fromMyPicks: true } })
                  }
                >
                  <div className="feed-context-menu__list-icon">
                    <AddPickTop width="20px" height="20px" />
                  </div>
                  Pick from a Link
                </li>
                <li className="feed-context-menu__list-item">
                  <Link to={`../@${username}/saved`}>
                    <div className="feed-context-menu__list-icon">
                      <AddPickTop width="20px" height="20px" />
                    </div>
                    Pick from Saved Collections
                  </Link>
                </li>
              </ul>
            </li>
          ) : null}

          {isInSaved || isInSavedFeed ? (
            <li
              className="feed-context-menu__list-item"
              onClick={() => openMod({ type: 'addPick', params: { fromMySaved: true } })}
            >
              <div className="feed-context-menu__list-icon">
                <SaveButton />
              </div>
              Save an Item
            </li>
          ) : null}

          {isInFeedsFilter && isInHome ? (
            <li className="feed-context-menu__list-item">
              <div className="feed-context-menu__list-icon">
                <Info />
              </div>
              See Feed Info
            </li>
          ) : null}

          {isInHome ? (
            <Fragment>
              <li className="feed-context-menu__list-item">
                <div className="feed-context-menu__list-icon">
                  <SortBy />
                </div>
                Sort by...
              </li>
              <li className="feed-context-menu__list-item">
                <div className="feed-context-menu__list-icon">
                  <Magnifier fill={'#000'} width={'20px'} height={'20px'} />
                </div>
                Search this Feed
              </li>
              <li className="feed-context-menu__list-item">
                <div className="feed-context-menu__list-icon feed-context-menu__list-icon--gallery">
                  <FeedGallery />
                </div>
                Change Item Layout
                <span className="feed-context-menu__arrow">
                  <Arrow />
                </span>
                <ul
                  className={`feed-context-menu__list feed-context-menu__submenu ${
                    isFloatingButtonPressed ? 'feed-context-menu__submenu--show' : ''
                  }`}
                >
                  <li
                    className="feed-context-menu__list-item"
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      setLayoutType('list')
                    }}
                  >
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--stack">
                      <FeedStack />
                    </div>
                    List
                  </li>
                  <li
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      setLayoutType('grid')
                    }}
                    className="feed-context-menu__list-item"
                  >
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--grid">
                      <FeedGrid />
                    </div>
                    Grid
                  </li>
                  <li
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      setLayoutType('gallery')
                    }}
                    className="feed-context-menu__list-item"
                  >
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--gallery">
                      <FeedGallery />
                    </div>
                    Gallery
                  </li>
                  <li className="feed-context-menu__list-item">
                    <div className="feed-context-menu__list-icon feed-context-menu__list-icon--stage">
                      <FeedStage />
                    </div>
                    Stage
                  </li>
                </ul>
              </li>
              <li className="feed-context-menu__list-item">
                <div className="feed-context-menu__list-icon">
                  <ViewSquare />
                </div>
                Change Thumbnail View
                <ul className="feed-context-menu__list feed-context-menu__submenu">
                  <li
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      this.handleThumbnailSwitch('trimmed')
                    }}
                    className="feed-context-menu__list-item"
                  >
                    <div className="feed-context-menu__list-icon">
                      <ViewTrim />
                    </div>
                    Trim
                  </li>
                  <li
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      this.handleThumbnailSwitch('squared')
                    }}
                    className="feed-context-menu__list-item"
                  >
                    <div className="feed-context-menu__list-icon">
                      <ViewSquare />
                    </div>
                    Square
                  </li>
                  <li
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      this.handleThumbnailSwitch('poster')
                    }}
                    className="feed-context-menu__list-item"
                  >
                    <div className="feed-context-menu__list-icon">
                      <ViewPoster />
                    </div>
                    Poster
                  </li>
                </ul>
              </li>
              <li
                className="feed-context-menu__list-item"
                onClick={() => {
                  openHelperMod({ type: 'editViewOptions' })
                }}
              >
                <div className="feed-context-menu__list-icon">
                  <DotMenu />
                </div>
                More View Options
              </li>
            </Fragment>
          ) : null}
        </ul>
      </div>
    )
  }
}

FeedContextMenu.propTypes = {
  isInFeedsFilter: pt.bool,
  openHelperMod: pt.func,
  isInCards: pt.bool,
  requestOpenCreateCollection: pt.func,
  isInCollection: pt.bool,
  isInSaved: pt.bool,
  openMod: pt.func,
  user: pt.object,
  directionLeft: pt.bool,
  isFloatingButtonPressed: pt.bool,
  isInSavedFeed: pt.bool,
  setThumbnailType: pt.func,
  setLayoutType: pt.func
}

const mapDispatchToProps = {
  openMod,
  openHelperMod,
  closeHelperMod,
  requestOpenCreateCollection,
  setThumbnailType,
  setLayoutType
}

const mapStateToProps = state => ({
  user: get(state, 'user.data.user')
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedContextMenu)
